import { Pipe, PipeTransform } from '@angular/core';
import {
  DocumentTypeEnum,
  DocumentTypeInfo,
} from '@qaroni-app/documents/types/document-type.enum';

@Pipe({
  name: 'employeeDocumentType',
  standalone: false,
})
export class EmployeeDocumentTypePipe implements PipeTransform {
  transform(value: DocumentTypeEnum): string {
    if (
      value &&
      Object.prototype.hasOwnProperty.call(DocumentTypeInfo, value)
    ) {
      return DocumentTypeInfo[value].name;
    }

    return value;
  }
}
